import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import partition from 'lodash/partition'
import withCentreTradingHours from '../../containers/with-centre-trading-hours'
import OpeningHoursModules from '../../components/opening-hours-modules'
import { getCentreStructuredData } from '../../helpers/get-centre-structured-data'
import Modules from '../../components/modules'
import withModules from '../../containers/with-modules'
import pagesHoc from '../pages-hoc'
import { MIN_DAYS_TO_SHOW } from '../../constants'
import TradingHoursList from '../../components/trading-hours-list'
import style from './index.scss'

const groupModules = modules =>
  partition(
    modules,
    module =>
      get(module, 'sys.contentTypeId') === 'basicContent' ||
      get(module, 'sys.contentTypeId') === 'contentBlock' ||
      get(module, 'sys.contentTypeId') === 'dynamicContent'
  )

const getOpenHoursModules = modules => groupModules(modules)[0]
const getOtherModules = modules => groupModules(modules)[1]

export const OpeningHours = ({ centre, centreTradingHours, modules }) => (
  <Fragment>
    <OpeningHoursModules centre={centre}>
      <Modules
        modules={getOpenHoursModules(modules)}
        centreTitle={centre.title}
      >
        <TradingHoursList
          minDays={MIN_DAYS_TO_SHOW}
          openHoursHeading="Hours"
          centreTradingHours={centreTradingHours}
        />
      </Modules>
    </OpeningHoursModules>
    <Modules
      className={style.initialContentGroup}
      modules={getOtherModules(modules)}
      centreTitle={centre.title}
    />
  </Fragment>
)

const rawOpeningHours = PropTypes.shape({
  tradingHours: PropTypes.array.isRequired,
  timeZone: PropTypes.string.isRequired,
  features: PropTypes.array,
})

OpeningHours.propTypes = {
  centre: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    physicalAddress: PropTypes.string,
    state: PropTypes.string,
    postcode: PropTypes.string,
    suburb: PropTypes.string,
    emailAddress: PropTypes.string,
    telephoneNumber: PropTypes.string,
    features: PropTypes.array,
  }).isRequired,
  centreTradingHours: rawOpeningHours,
  modules: PropTypes.array,
}

OpeningHours.defaultProps = {
  modules: [],
}

export const getMetaData = ({ canonical, centre, tradingHours }) => {
  const title = `Westfield ${centre.title} Opening Hours | Centre Trading Hours`
  const description = `Westfield ${centre.title} - View opening hours for regular business days. Check special or extended trading hours for public holidays at Westfield ${centre.title}.`

  return {
    title,
    description,
    schema: getCentreStructuredData({
      url: canonical,
      centre,
      name: title,
      description,
      tradingHours,
    }),
  }
}

export default withCentreTradingHours(
  withModules(pagesHoc(OpeningHours, getMetaData))
)
